// Per-villa highlight colors. Used by BOTH the Home calendar bars and the
// booking cards so they always match.
//
// Current/upcoming bookings use the villa's FULL colour (properties.color).
// Past bookings use a LIGHTER tint of that same colour (lightenPast — the hue
// blended toward white) so they read as "past" while still showing the villa.
// Their date number is also faded (the .cld_past rule in home.scss).

export const PAST_COLOR = "#E8E9EB";

const hexToRgb = (hex: string) => {
  const m = hex.replace("#", "");
  if (m.length !== 6) return null;
  return {
    r: parseInt(m.slice(0, 2), 16),
    g: parseInt(m.slice(2, 4), 16),
    b: parseInt(m.slice(4, 6), 16),
  };
};

// Blend a hex colour toward white; t = how far toward white (0 = same, 1 = white).
const lighten = (hex: string, t: number): string => {
  const c = hexToRgb(hex);
  if (!c) return hex;
  const mix = (x: number) => Math.round(x * (1 - t) + 255 * t);
  const parts = [mix(c.r), mix(c.g), mix(c.b)];
  return `#${parts.map((n) => n.toString(16).padStart(2, "0")).join("")}`;
};

// Highlight = the villa's own stored color; fall back to the default beige.
export const villaHighlight = (color?: string): string => color || "#ECE3D3";

// Past bookings: a lighter tint of the villa colour (blended halfway to white),
// so past bars are clearly lighter than present/future ones but keep the hue.
export const lightenPast = (color?: string): string =>
  lighten(villaHighlight(color), 0.5);
